// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface FeaturedCategoriesState {
    [key: string]: {
        isLoading: boolean;
        data: CategoryModel[];
        failedMessage: string;
    };
}

const initialState: FeaturedCategoriesState = {};

const reducer = {
    "xFeaturedCategories/BeginLoadFeaturedCategories": (
        draft: Draft<FeaturedCategoriesState>,
        action: { key: string },
    ) => {
        draft[action.key] = {
            isLoading: true,
            data: [],
            failedMessage: "",
        };
    },
    "xFeaturedCategories/FailedToLoadFeaturedCategories": (
        draft: Draft<FeaturedCategoriesState>,
        action: { failedMessage: string; key: string },
    ) => {
        draft[action.key] = {
            isLoading: false,
            data: [],
            failedMessage: action.failedMessage,
        };
    },
    "xFeaturedCategories/CompleteLoadFeaturedCategories": (
        draft: Draft<FeaturedCategoriesState>,
        action: { data: CategoryModel[]; key: string },
    ) => {
        draft[action.key] = {
            isLoading: false,
            data: action.data,
            failedMessage: "",
        };
    },
};

const xFeaturedCategories = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xFeaturedCategories = xFeaturedCategories;

export type xFeaturedCategories = {
    xFeaturedCategories: FeaturedCategoriesState;
} & ApplicationState;

type xFeaturedCategoriesReducers = {
    [key: string]: typeof xFeaturedCategories;
};

export type xFeaturedCategoriesActions = Parameters<xFeaturedCategoriesReducers[keyof xFeaturedCategoriesReducers]>[1];
